module.exports = __webpack_public_path__ + "img/5_growth_catalyst.c88cf84d.png";